function getBaseRequestConfig(accessToken, contentType = 'application/json') {
  const headers = {};
  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const config = {
    method: 'GET',
    mode: 'cors',
    headers,
    timeout: 14000,
  };

  return config;
}

const LOCAL_BASE_PATH = process.env.REACT_APP_API_URL;

const LOCAL_HLF_BASE_PATH = process.env.REACT_APP_HLF_API_URL;

const LOCAL_HLF_FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_API_URL ||
  'https://feapi.dev.c3.hjart-lungfonden.se';

export {
  getBaseRequestConfig,
  LOCAL_BASE_PATH,
  LOCAL_HLF_BASE_PATH,
  LOCAL_HLF_FRONTEND_URL,
};
